<template>
  <div class="page-container-line">
    <div class="h-full flex">
      <div :style="{ width: leftWidth + 'px' }" ref="leftContainer">
        <a-input-search
          @search="keyWordSearch(1)"
          enterButton
          placeholder="模糊查询测点/组合名称..."
          style="width:100%;margin-bottom:10px"
          v-model="keyWord"
        />
        <div class="left-box" ref="colbox" style="height:calc(100% - 85px)">
          <a-collapse @change="collapseChange" accordion class="h-full collapse" ghost ref="cbox" v-model="activeKey">
            <a-collapse-panel header="测点组" key="groups">
              <template slot="extra">
                <div style="display: grid;grid-template-rows: 13px 13px;margin-top:-5px;">
                  <a-tooltip title="升序">
                    <a>
                      <a-icon @click="handleSort($event, 1, 'asc')" class="search-icon-m" type="up" />
                    </a>
                  </a-tooltip>
                  <a-tooltip title="降序">
                    <a>
                      <a-icon @click="handleSort($event, 1, 'desc')" class="search-icon-m" type="down" />
                    </a>
                  </a-tooltip>
                </div>
              </template>
              <a-tree
                :checkedKeys="checkedGroups"
                :expandedKeys="['root']"
                :treeData="groups.list"
                @check="handleGroupTreeCheck"
                autoExpandParent
                blockNode
                checkable
              >
                <template v-slot:title="nodeData">
                  <span>{{ nodeData.title }}</span>
                  <a-dropdown>
                    <a-button icon="setting" size="small" type="link"></a-button>
                    <a-menu slot="overlay">
                      <a-menu-item @click="handleEdit(nodeData)">
                        <a-icon type="edit" />编辑
                      </a-menu-item>
                      <a-menu-item @click="handleCopy(nodeData)">
                        <a-icon type="copy" />复制
                      </a-menu-item>
                      <a-menu-item>
                        <a-popconfirm @confirm="handleDelete(nodeData.id)" title="确定删除吗?">
                          <a-icon type="delete" />删除
                        </a-popconfirm>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>
              </a-tree>
              <div class="flex justify-between">
                <a-pagination
                  :pageSize="groups.pageSize"
                  :total="groups.total"
                  @change="keyWordSearch"
                  simple
                  v-model:current="groups.pageNo"
                ></a-pagination>

                <div class="ant-pagination ant-pagination-simple">
                  {{ (groups.pageNo - 1) * groups.pageSize + 1 }}-{{
                  groups.pageNo * groups.pageSize > groups.total ? groups.total : groups.pageNo * groups.pageSize
                  }}
                  共{{ groups.total }}条
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel class="wsxx" header="区域-设备" key="region">
              <a-row
                align="middle"
                style="position:fixed;background-color: #fff;z-index: 999;margin: -16px;padding: 15px;width: 290px;"
                type="flex"
              >
                <a-col span="12">
                  <a-button
                    :disabled="checkedPoints == null || checkedPoints.length === 0"
                    @click="favoritePointGroup2"
                    type="primary"
                  >收藏点组</a-button>
                </a-col>
              </a-row>

              <a-tree
                :load-data="loadRegionTreeData"
                :selectable="false"
                :tree-data="regionTreeData"
                @check="checkTreeNode"
                checkable
                style="margin-top:38px"
              >
                <template v-slot:icon="props">
                  <a-icon :type="props.node.iconType" />
                </template>
              </a-tree>
            </a-collapse-panel>
            <a-collapse-panel class="wsxx" header="流域-设备" key="trees">
              <a-row
                align="middle"
                style="position:fixed;background-color: #fff;z-index: 999;margin: -16px;padding: 15px;width: 290px;"
                type="flex"
              >
                <a-col span="12">
                  <a-button
                    :disabled="checkedPoints == null || checkedPoints.length === 0"
                    @click="favoritePointGroup2"
                    type="primary"
                  >收藏点组</a-button>
                </a-col>
              </a-row>

              <a-tree
                :load-data="loadTreeData"
                :selectable="false"
                :tree-data="pointTreeData"
                @check="checkTreeNode"
                checkable
                style="margin-top:38px"
              >
                <!-- icon图标，process节点用cluster dev节点用sliders point节点用line-chart -->
                <template v-slot:icon="props">
                  <a-icon :type="props.node.iconType" />
                </template>
              </a-tree>
            </a-collapse-panel>
            <a-collapse-panel class="wsxx" header="所有测点" key="points">
              <template slot="extra">
                <div style="display: grid;grid-template-rows: 13px 13px;margin-top:-5px;">
                  <a-tooltip title="升序">
                    <a>
                      <a-icon @click="handleSort($event, 2, 'asc')" class="search-icon-m" type="up" />
                    </a>
                  </a-tooltip>
                  <a-tooltip title="降序">
                    <a>
                      <a-icon @click="handleSort($event, 2, 'desc')" class="search-icon-m" type="down" />
                    </a>
                  </a-tooltip>
                </div>
              </template>
              <a-row
                align="middle"
                style="position:fixed;background-color: #fff;z-index: 999;margin: -16px;padding: 15px;width: 295px;"
                type="flex"
              >
                <a-col span="12">
                  <a-button
                    :disabled="checkedPoints == null || checkedPoints.length === 0"
                    @click="favoritePointGroup"
                    type="primary"
                  >收藏点组</a-button>
                </a-col>
                <a-col span="12">
                  <a-checkbox :checked="onlyFloatPoints" @change="onPointsTypeChange">只看模拟量</a-checkbox>
                </a-col>
              </a-row>
              <a-tree
                :checkedKeys="checkedPoints"
                :expandedKeys="['root']"
                :treeData="points.list"
                @check="handlePointTreeCheck"
                autoExpandParent
                checkable
                style="margin-top:38px"
              ></a-tree>
              <div class="flex justify-between">
                <a-pagination
                  :pageSize="points.pageSize"
                  :total="points.total"
                  @change="keyWordSearch"
                  simple
                  v-model:current="points.pageNo"
                />
                <div>
                  {{ (points.pageNo - 1) * points.pageSize + 1 }}-{{
                  points.pageNo * points.pageSize > points.total ? points.total : points.pageNo * points.pageSize
                  }}
                  共{{ points.total }}条
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
      <div @mousedown="startResize" class="resize-bar"></div>

      <div :style="{ width: 'calc(100% - ' + leftWidth + 'px)' }" class="flex-1">
        <points-line-chart ref="lineChart"></points-line-chart>
      </div>
    </div>
    <iot-model-points-group-modal @close="modalFormOk" @ok="modalFormOk" ref="modalForm" />
  </div>
</template>

<script>
  import ACol from 'ant-design-vue/es/grid/Col'
  import { deleteAction, getAction } from '@/api/manage'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import IotModelPointsGroupModal from './modules/IotModelPointsGroupModal'
  import PointsLineChart from './modules/PointsLineChart.vue'

  export default {
    name: 'DataLine',
    mixins: [JeecgListMixin],
    components: {
      ACol,
      IotModelPointsGroupModal,
      PointsLineChart
    },
    data () {
      return {
        loading: true,
        modelId: '',
        pointCodes: [],
        keyWord: '',
        onlyFloatPoints: true,
        activeKey: 'groups',
        points: {
          total: 0,
          list: [],
          pageNo: 1,
          pageSize: 100
        },
        groups: {
          total: 0,
          list: [],
          pageNo: 1,
          pageSize: 100
        },
        processsPoints: [],
        pointTreeData: [],
        timeRange: [],
        dataQueryParam: {},
        projectTreeData: [],
        fastTimeRange: '最近24小时',
        regionTreeData: [],
        checkedGroups: [],
        checkedPoints: [],
        checkedPointsList: [],
        pointsLineOpts: {},
        url: {
          addPointsGroupUrl: '/monitor/iotModelPointsGroup/add',
          getPointslist: '/monitor/iotModelPoints/listNoValue',
          getPointData: '/monitor/data/pointdata',
          getPointsGroupList: '/monitor/iotModelPointsGroup/list',
          getPointsGroupData: '/monitor/iotModelPointsGroup/pointsGroupData',
          deletePointsGroupData: '/monitor/iotModelPointsGroup/delete',
          getAreaList: '/device/devAreaLocation/list',
          getDevice: '/device/devList/simplelist',
          getPoint: '/monitor/iotModelPoints/list',
          getDevRegion: '/device/devList/getDevRegion',
        },
        height: 0,

        leftWidth: 350,
        isResizing: false
      }
    },
    created () {
      this.keyWordSearch()
      this.$nextTick(() => {
        this.collapseChange()
      })
      this.loadTreeData()
      this.loadRegionTreeData();
    },
    methods: {
      checkTreeNode (checkedKeys, e) {
        const realCheckedKeys = checkedKeys.filter(key => key.toLocaleUpperCase().startsWith('T_'))
        this.checkedPoints = realCheckedKeys
        this.loadData()
      },
      //
      async loadRegionTreeData (treeNode) {
        if (!treeNode) {
          try {
            const res = await getAction(this.url.getDevRegion)
            if (res.success) {
              this.regionTreeData.push(
                ...res.result.map(node => ({
                  key: node.region,
                  title: node.region_name,
                  type: 'region'
                }))
              )
            }
          } catch (error) {
            // 处理异步请求的错误
            console.error('Error loading process data:', error)
          }
        } else {
          const type = treeNode.dataRef.type
          if (type === 'region') {
            try {
              const res = await getAction(this.url.getDevice, { region: treeNode.dataRef.key, pageSize: 9999 })
              console.log(res);
              
              if (res.success && res.result && Array.isArray(res.result.records)) {
                const nodes = res.result.records.map(n => ({
                  key: n.id,
                  title: n.devName,
                  type: 'dev'
                }))
                treeNode.dataRef.children = nodes
                this.regionTreeData = [...this.regionTreeData]
              } else {
                treeNode.dataRef.children = []
              }
            } catch (error) {
              console.error('Error loading device data:', error)
              treeNode.dataRef.children = []
            }
          } else if (type === 'dev') {
            try {
              const devId = treeNode.dataRef.key
              const params = {
                devId: devId,
                column: 'pointName',
                order: 'asc',
                pageNo: 1,
                pageSize: 9999
              }
              const res = await getAction(this.url.getPoint, params)
              if (res.success) {
                const nodes = res.result.records.map(n => ({
                  key: n.pointCode,
                  title: n.pointName,
                  type: 'point',
                  isLeaf: true
                }))
                treeNode.dataRef.children = nodes
                this.regionTreeData = [...this.regionTreeData]
                // 如果父节点已选中，自动加载曲线
                if (nodes.length && treeNode.checked) {
                  this.checkedPoints.push(...nodes.map(n => n.key))
                  this.loadData()
                }
              }
            } catch (error) {
              // 处理异步请求的错误
              console.error('Error loading point data:', error)
            }
          }
        }
      },
      async loadTreeData (treeNode) {
        if (!treeNode) {
          try {
            const res = await getAction(this.url.getAreaList, {
              column: 'areaName',
              order: 'asc',
              delFlag: 0,
              pageNo: 1,
              pageSize: 1000
            })
            if (res.success) {
              this.pointTreeData.push(
                //树节点icon为slot:icon
                ...res.result.records.map(node => ({
                  key: node.id,
                  title: node.areaName,
                  type: 'process'
                }))
              )
            }
          } catch (error) {
            // 处理异步请求的错误
            console.error('Error loading process data:', error)
          }
        } else {
          const type = treeNode.dataRef.type
          if (type === 'process') {
            try {
              const res = await getAction(this.url.getDevice, { areaId: treeNode.dataRef.key, pageSize: 9999 })

            if (res.success && res.result && Array.isArray(res.result.records)) {
                const nodes = res.result.records.map(n => ({
                  key: n.id,
                  title: n.devName,
                  type: 'dev'
                }))
                treeNode.dataRef.children = nodes
                this.pointTreeData = [...this.pointTreeData]
              } else {
                treeNode.dataRef.children = []
              }
            } catch (error) {
              // 处理异步请求的错误
              console.error('Error loading device data:', error)
            }
          } else if (type === 'dev') {
            try {
              const devId = treeNode.dataRef.key.includes('others') ? '' : treeNode.dataRef.key
              const params = {
                devId: devId,
                column: 'pointName',
                order: 'asc',
                pageNo: 1,
                pageSize: 9999
              }
              if (!params.devId) {
                params.areaId = treeNode.$parent.dataRef.key
              }
              const res = await getAction(this.url.getPoint, params)
              if (res.success) {
                const nodes = res.result.records.map(n => ({
                  key: n.pointCode,
                  title: n.pointName,
                  type: 'point',
                  isLeaf: true
                }))
                treeNode.dataRef.children = nodes
                this.pointTreeData = [...this.pointTreeData]
                // 如果父节点已选中，自动加载曲线
                if (nodes.length && treeNode.checked) {
                  this.checkedPoints.push(...nodes.map(n => n.key))
                  this.loadData()
                }
              }
            } catch (error) {
              // 处理异步请求的错误
              console.error('Error loading point data:', error)
            }
          }
        }
      },
      loadData () {
        const pointsStr = this.checkedPoints ? this.checkedPoints.join(',') : ''
        this.$nextTick(() => {
          this.$refs.lineChart.loadData(pointsStr)
        })
      },
      onPointsTypeChange (e) {
        this.onlyFloatPoints = e.target.checked
        this.keyWordSearch()
      },
      handleSort (event, searchType, order) {
        this.keyWordSearch(searchType, order)
        event.stopPropagation()
      },
      keyWordSearch (searchType, order) {
        if (searchType && searchType === 1) {
          this.points.pageNo = 1
          this.groups.pageNo = 1
        }
        if (this.activeKey === 'points') {
          const parms = {
            keyWord: this.keyWord,
            pageNo: this.points.pageNo,
            pageSize: this.points.pageSize,
            column: 'pointName',
            order: order
          }
          if (this.onlyFloatPoints) {
            parms.dataType = 'float32'
          }
          getAction(this.url.getPointslist, parms).then(res => {
            if (res.success) {
              if (res.result.total) {
                this.points.total = res.result.total
              } else {
                this.points.total = 0
              }
              res.result.records.forEach(node => {
                node.key = node.pointCode
                node.title = node.pointName
                node.isLeaf = true
                node.checkable = true
              })
              this.points.list = res.result.records
            } else {
              this.$message.error(res.message)
            }
          })
        } else if (this.activeKey === 'groups') {
          const parms = {
            groupName: this.keyWord,
            pageNo: this.groups.pageNo,
            pageSize: this.groups.pageSize,
            userId: this.$ls.get('Login_UserId'),
            column: 'groupName',
            order: order
          }
          getAction(this.url.getPointsGroupList, parms).then(res => {
            if (res.success) {
              if (res.result.total) {
                this.groups.total = res.result.total
              } else {
                this.groups.total = 0
              }
              res.result.records.forEach(node => {
                node.key = node.id
                node.title = node.groupName
                node.isLeaf = true
                node.checkable = true
              })
              this.groups.list = res.result.records
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      handlePointTreeCheck (checkedKeys) {
        this.checkedPoints = checkedKeys
          .filter(node => node !== 'root')
          .sort((n1, n2) => {
            return n1 - n2
          })
        this.loadData()
      },
      handleGroupTreeCheck (checkedKeys, { node }) {
        this.checkedGroups = checkedKeys

        this.checkedPointsList.push(node.dataRef)
        this.checkedPoints = []
        if (validatenotnull(checkedKeys) && checkedKeys.length >= 0) {
          checkedKeys.forEach(key => {
            let data = this.checkedPointsList.filter(item => {
              return key == item.id
            })
            this.checkedPoints.push(data[0].iotModelPointsGroupMenberList.map(node => node.pointCode))
          })
        }
        this.loadData()
      },
      favoritePointGroup () {
        const checkedPointList = this.points.list
          .filter(node => this.checkedPoints.filter(key => key === node.pointCode).length > 0)
          .sort((n1, n2) => {
            return n1 - n2
          })
        this.handleAdd(checkedPointList)
      },
      favoritePointGroup2 () {
        const checkedPointList = []
        const that = this
        that.pointTreeData.map(process => {
          if (process.children && process.children.length) {
            process.children.map(dev => {
              if (dev.children && dev.children.length) {
                dev.children.map(point => {
                  if (that.checkedPoints.includes(point.key)) {
                    checkedPointList.push({ pointCode: point.key, pointName: point.title })
                  }
                })
              }
            })
          }
        })
        this.handleAdd(checkedPointList)
      },
      handleAdd: function (checkedPointList) {
        this.$refs.modalForm.add(checkedPointList)
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
      handleEdit: function (nodeData) {
        this.$refs.modalForm.edit(nodeData)
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
      },
      handleCopy: function (nodeData) {
        this.$refs.modalForm.copy(nodeData)
        this.$refs.modalForm.title = '复制'
        this.$refs.modalForm.disableSubmit = false
      },
      handleDelete: function (id) {
        var that = this
        deleteAction(that.url.deletePointsGroupData, { id: id }).then(res => {
          if (res.success) {
            // 重新计算分页问题
            that.$message.success(res.message)
            this.checkedPoints = []
            this.keyWordSearch()
          } else {
            that.$message.warning(res.message)
          }
        })
      },
      collapseChange: function (v) {
        this.checkedPoints = []
        this.keyWordSearch()
        const that = this
        this.$nextTick(() => {
          const cbox = that.$refs['cbox']

          const height = cbox.$el.offsetHeight
          if (!this.height) {
            this.height = height
          }
          const dom = document.querySelector('.ant-collapse-content-active .ant-collapse-content-box')
          dom && (dom.style.height = this.height - 94 + 'px')
        })
      },
      modalFormOk () {
        this.collapseChange()
      },
      startResize (event) {
        this.isResizing = true
        document.addEventListener('mousemove', this.handleResize)
        document.addEventListener('mouseup', this.stopResize)
      },
      handleResize (event) {
        if (this.isResizing) {
          const newWidth = event.clientX - this.$refs.leftContainer.getBoundingClientRect().left
          this.leftWidth = newWidth > 200 ? newWidth : 200 // 限制最小宽度为200px
        }
      },
      stopResize () {
        this.isResizing = false
        document.removeEventListener('mousemove', this.handleResize)
        document.removeEventListener('mouseup', this.stopResize)
      }
    }
  }
</script>

<style lang="less" scoped>
  .page-container-line {
    background: #fff;
    height: calc(100vh - 148px);
    padding: 8px;
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
  .left-box {
    ::v-deep {
      .ant-collapse {
        background: #fff;
      }
    }
  }
  ::v-deep {
    .ant-collapse {
      // background: #fff;
      .ant-collapse-content-box {
        height: calc(100% - 46px);
        overflow-y: scroll;
      }
      .collapse {
        overflow-y: scroll;
      }
    }
  }

  /deep/ .ant-pagination-prev,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    margin-right: 0;
  }

  /deep/ .ant-pagination-simple .ant-pagination-simple-pager input {
    margin-right: 0;
  }

  /deep/ .ant-pagination-simple .ant-pagination-simple-pager {
    display: inline-block;
    height: 24px;
    margin-right: 0;
  }

  /deep/ .ant-pagination-prev,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    min-width: 28px;
    height: 26px;
  }

  /deep/ .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    min-width: 28px;
    height: 26px;
  }

  /deep/ .ant-pagination-slash {
    margin: 0 5px 0 0;
  }

  .resize-bar {
    width: 2px;
    cursor: ew-resize;
    background-color: #ccc;
    z-index: 1000;
  }
</style>
